import { css } from '@emotion/react'
import common from 'shared/styles'

const styles = () => {
    return {
        root: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
            height: 100%;
            overflow: hidden;
        `,
        video: css`
            padding: 0;
            flex-grow: 1;
            height: 100%;
        `,
        camera: css`
            width: 100%;
            height: 100%;
            object-fit: fill;
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
            flex-direction: column;
            padding: 0;
            flex-grow: 0;
            width: 10%;
        `,
        flash: css`
            margin-bottom: 60px;
            padding: 20px;
        `,
        cameraButton: css`
            padding: 20px;
        `,
    }
}

export default styles
